// Shared formatting for the Payouts pages. Amounts arrive in cents.

// Monday of the week containing `d`, as a yyyy-mm-dd string built from LOCAL
// date parts (using toISOString would shift the day under UTC+2 / SAST).
export function mondayOf(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  const dow = x.getDay();
  x.setDate(x.getDate() - (dow === 0 ? 6 : dow - 1));
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, '0');
  const day = String(x.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export const rands = (cents) => `${cents < 0 ? '-' : ''}R${(Math.abs(cents || 0) / 100).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (s) => new Date(s).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' });
